module.exports = __webpack_public_path__ + "static/img/1.2c72302.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news28/1.png
// module id = 9nxd
// module chunks = 1